var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "65px",
    viewBox: "0 0 200 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-active",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0.5 C2.51471863,0.5 0.5,2.51471863 0.5,5 L0.5,60 C0.5,62.4852814 2.51471863,64.5 5,64.5 L181.10451,64.5 C182.828528,64.5 184.401008,63.5150167 185.153382,61.963833 L198.491767,34.463833 C199.093272,33.2236994 199.093272,31.7763006 198.491767,30.536167 L185.153382,3.03616695 C184.401008,1.48498326 182.828528,0.5 181.10451,0.5 L5,0.5 Z",
    id: "Rectangle-5",
    stroke: "#234078",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuActive);
export default __webpack_public_path__ + "static/media/menu-active.8a109bf7353d5b8c92828037fd559854.svg";
export { ForwardRef as ReactComponent };